import { createApp } from 'vue'
import App from './App.vue'
const app = createApp(App);

// console log 막기 (production = 배포 단계에서 막기)

// if (process.env.NODE_ENV === 'development') {
//     console.log = () => {};
//     console.warn = () => {};
//     console.error = () => {};
// }

// Style Reset
import '@/style/reset.module.scss';
import '@/style/skeleton.css';

import '@/style/color.module.scss';


// Router
import router from './route';
import login from '@/api/login';
import menu from '@/common/menu';

import VueTheMask from 'vue-the-mask'


// Store
import store from './store/store';
import mixin from './store/mixin';

import { plugin as Slicksort } from 'vue-slicksort';

import VSwatches from 'vue3-swatches'
import 'vue3-swatches/dist/style.css'

//.use(createNaverMap, { clientId: "87ekucnt2l" })
app
.mixin(mixin)
.use(router)
.use(store)
.use(login)
.use(menu)
.use(VueTheMask)
.use(Slicksort)
.use(VSwatches)
.mount('#app')
